import { createAxiosClient } from './create.axios.client'


const client = createAxiosClient()
export default client
